import React from "react";
import { useState } from "react";
import { Button, Container, Row, Col, Form, Modal } from "react-bootstrap";

async function postData(url, data) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  const responseData = await response.json();
  return responseData;
}

function ContactMe() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [showModal, setShowModal] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    try {
      const responseData = await postData("https://dennis89linebot.herokuapp.com/feedback", formData);

      console.log(responseData);
      setShowModal(true);
      setFormData({
        name: "",
        email: "",
        message: ""
      });
    } catch (error) {
      console.error(error);
      // 进行错误处理或显示错误消息
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value
    }));
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="App">
      <Container className="my-container">
        <Row>
          <Col>
          <br />
            <h2>Contact</h2>
            <p>Any issue reports and suggestions are welcome. Your feedback is the best motivation for us to improve the tools.</p>
            <Form onSubmit={handleFormSubmit}>
              <Form.Group controlId="name">
                <Form.Label>Name：</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Please input your name"
                  required
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="email">
                <Form.Label>Mail：</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Please input your email"
                  required
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="message">
                <Form.Label>Message：</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Please input your message"
                  required
                  value={formData.message}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <br />
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Message Received</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Thank you for your message. We have received it and will reply to you
          soon.
        </Modal.Body>
        <Modal.Footer>
        
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ContactMe;
